// OOH!TWINS Makeover: Pause-Knopf für das Laufband, Slider-Stopp bei reduzierter Bewegung (Barrierefreiheit). Keine weiteren Eingriffe.
(function () {
  var ICON = '<svg class="ooh-pause__pause" viewBox="0 0 14 14" aria-hidden="true"><rect x="2" y="1" width="3.5" height="12" rx="1"/><rect x="8.5" y="1" width="3.5" height="12" rx="1"/></svg><svg class="ooh-pause__play" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5v11l9-5.5z"/></svg>';
  function button(label) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'ooh-pause'; b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', label); b.innerHTML = ICON;
    return b;
  }
  // Poster der Video-Slides erst nach dem Laden setzen (nicht auf dem kritischen Pfad)
  window.addEventListener('load', function () { document.querySelectorAll('video[data-poster]').forEach(function (v) { v.poster = v.getAttribute('data-poster'); }); });
  window.addEventListener('load', function () { setTimeout(function () { document.querySelectorAll('.announcement-bar--marquee').forEach(function (m) { m.classList.add('is-running'); }); }, 800); });
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Laufband
  var marquee = document.querySelector('.announcement-bar--marquee');
  if (marquee) {
    var bar = marquee.closest('.announcement-bar');
    var mb = button('Laufband anhalten');
    mb.addEventListener('click', function () {
      var paused = marquee.classList.toggle('is-paused');
      mb.setAttribute('aria-pressed', String(paused)); mb.setAttribute('aria-label', paused ? 'Laufband weiterlaufen lassen' : 'Laufband anhalten');
    });
    bar.appendChild(mb);
    if (reduce) mb.click();
  }
  // Hero-Slider (Flickity): kein Knopf, bei reduzierter Bewegung wird die Automatik gestoppt
  var slider = document.querySelector('slide-show.main-slideshow');
  if (slider && slider.dataset.autoplay && reduce) {
    setTimeout(function () { var f = window.Flickity && window.Flickity.data(slider); if (f) f.stopPlayer(); }, 1500);
  }
  // Hero: kein Stopp/Play-Knopf, auch kein vom Theme oder Browser eingefügter (Steuerelemente der Hintergrundvideos, Autoplay-Knöpfe)
  var heroSec = document.querySelector('.section-slideshow');
  if (heroSec) {
    var PAUSE_RE = /pause|play|autoplay|stop|wiedergabe|anhalten/i;
    var cleanHero = function () {
      heroSec.querySelectorAll('button,[role="button"]').forEach(function (e) {
        if (PAUSE_RE.test([e.getAttribute('aria-label'), e.title, e.className].join(' '))) e.remove();
      });
      heroSec.querySelectorAll('video').forEach(function (v) { v.controls = false; v.disablePictureInPicture = true; v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback'); });
    };
    cleanHero();
    new MutationObserver(cleanHero).observe(heroSec, { childList: true, subtree: true });
  }
  // Nach-oben-Knopf: nur beim Hochscrollen (nach zwei Bildschirmen am Handy, nach einem am Desktop) und nur kurz, damit er keinen Text überdeckt
  var top = document.querySelector('back-to-top');
  if (top) {
    var lastY = window.scrollY, hideTimer = null;
    window.addEventListener('scroll', function () {
      var y = window.scrollY, up = y < lastY - 4, down = y > lastY + 4, min = (window.innerWidth < 768 ? 2 : 1) * window.innerHeight;
      if (down || y <= min) { top.classList.remove('ooh-hochscroll'); }
      else if (up) { top.classList.add('ooh-hochscroll'); clearTimeout(hideTimer); hideTimer = setTimeout(function () { top.classList.remove('ooh-hochscroll'); }, 2500); }
      if (up || down) lastY = y;
    }, { passive: true });
    top.addEventListener('focusin', function () { top.classList.add('ooh-hochscroll'); });
  }
})();

(function () {
  // Namen für Theme-Knöpfe ohne Text, Datenschutz-Link auf https, Meta-Kästen der Blogkarten ohne eigene Landmarke
  var t = document.querySelector('summary.mobile-toggle'); if (t && !t.getAttribute('aria-label')) t.setAttribute('aria-label', 'Menü öffnen');
  document.querySelectorAll('.next > a, .prev > a').forEach(function (a) { if (!a.textContent.trim() && !a.getAttribute('aria-label')) a.setAttribute('aria-label', a.parentElement.classList.contains('next') ? 'Nächste Seite' : 'Vorherige Seite'); });
  document.querySelectorAll('a[href^="http://ooh-twins.de"], a[href^="http://www.ooh-twins.de"]').forEach(function (a) { a.href = a.getAttribute('href').replace(/^http:/, 'https:'); });
  document.querySelectorAll('aside.post-meta').forEach(function (s) { s.setAttribute('role', 'none'); });
})();
